import { Injectable } from '@angular/core';
import * as ExcelJS from 'exceljs';

@Injectable({
  providedIn: 'root',
})
export class DataExportService {
  public async saveFile(workbook: ExcelJS.Workbook, fileName: string, format: 'csv' | 'xlsx'): Promise<void> {
    if (fileName.indexOf('.') < 0) {
      fileName += `.${format}`;
    }

    if (format === 'csv') {
      await this.saveAsCsv(workbook, fileName);
    } else {
      await this.saveAsXlsx(workbook, fileName);
    }
  }

  private async saveAsCsv(workbook: ExcelJS.Workbook, fileName: string) {
    const buffer = await workbook.csv.writeBuffer();

    // add \ufeff at the beginning to tell excel, this csv is UTF-8 encoded :D https://stackoverflow.com/a/53401575/7430546
    const blob = new Blob(['\ufeff', buffer], { type: 'text/csv;charset=utf-8' });
    this.saveBlobFile(blob, fileName);
  }

  private async saveAsXlsx(workbook: ExcelJS.Workbook, fileName: string) {
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    this.saveBlobFile(blob, fileName);
  }

  private saveBlobFile(blob: Blob, fileName: string) {
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = fileName;
    a.click();
    a.remove();
  }
}
